<h2>Customer type</h2>

<div class="spacer"></div>

<data-table (custom)="onSelect($event)"
                [columns]="[{prop: 'title'}]"
                [dataProvider]="organisationService"
                [title]="'Organisations'"
                alternative_icon=null
                icon="add_circle"
></data-table>

<div class="spacer"></div>

<div class="button-right-container">
  <button (click)="abort()" class="ibexfusion-raised-button" mat-button>cancel</button>
</div>
